/* eslint-disable no-use-before-define */

/* eslint-disable no-unused-vars */

/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import { Animated, Platform, StyleProp, StyleSheet, TextStyle, View, ViewStyle } from "react-native";
import SVG_Svg, {
  ClipPath as SVG_ClipPath,
  Defs,
  G as SVG_G,
  GProps,
  Path as SVG_Path,
  PathProps,
} from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: desc */

/***/

const ClipPath = Animated.createAnimatedComponent(SVG_ClipPath);
const Path = Animated.createAnimatedComponent<
  React.ComponentClass<
    PathProps & {
      style?: StyleProp<ViewStyle>;
    }
  >
>(SVG_Path);
const G = Animated.createAnimatedComponent<
  React.ComponentClass<
    GProps & {
      style?: StyleProp<ViewStyle>;
    }
  >
>(SVG_G);
const Svg = Animated.createAnimatedComponent(SVG_Svg);

/*
 * -------------------------------------------------------------------------
 *
 *  /$$$$$$                                /$$$$$$$  /$$
 * |_  $$_/                               | $$__  $$| $$
 *   | $$   /$$$$$$/$$$$   /$$$$$$        | $$  \ $$| $$ /$$   /$$  /$$$$$$
 *   | $$  | $$_  $$_  $$ /$$__  $$       | $$$$$$$ | $$| $$  | $$ /$$__  $$
 *   | $$  | $$ \ $$ \ $$| $$  \ $$       | $$__  $$| $$| $$  | $$| $$$$$$$$
 *   | $$  | $$ | $$ | $$| $$  | $$       | $$  \ $$| $$| $$  | $$| $$_____/
 *  /$$$$$$| $$ | $$ | $$| $$$$$$$/  /$$  | $$$$$$$/| $$|  $$$$$$/|  $$$$$$$
 * |______/|__/ |__/ |__/| $$____/  |__/  |_______/ |__/ \______/  \_______/
 *                       | $$
 *                       | $$
 *                       |__/
 *
 * -------------------------------------------------------------------------
 *
 * ORIGINAL SVG
 * ---------------------------------
 * <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none"> <desc id="IMP.BLUE">{"#InstagramIcon":{"type":"SELECTOR","constraint":"xMinYMin meet","width":25,"height":25},"#Group":{"type":"SELECTOR","constraint":"none","width":25,"height":25},"#Vector":{"type":"SELECTOR","constraint":"none","width":2.5,"height":2.4999914169311523},"transforms":{}}</desc>
 * <g id="InstagramIcon" clip-path="url(#clip0)">
 * <g id="Group">
 * <g id="Group_2">
 * <g id="Group_3">
 * <path id="Vector" d="M17.875 0H7.125C3.20835 0 0 3.20835 0 7.125V17.875C0 21.7916 3.20835 25 7.125 25H17.875C21.7916 25 25 21.7916 25 17.875V7.125C25 3.20835 21.7916 0 17.875 0ZM24.1667 17.875C24.1667 21.3333 21.3333 24.1667 17.875 24.1667H7.125C3.66665 24.1667 0.83335 21.3333 0.83335 17.875V7.125C0.83335 3.66665 3.6667 0.83335 7.125 0.83335H17.875C21.3333 0.83335 24.1667 3.6667 24.1667 7.125V17.875Z" fill="black"/>
 * <path id="Vector_2" d="M12.5006 5.83331C8.83398 5.83331 5.83398 8.83331 5.83398 12.5C5.83398 16.1666 8.83398 19.1666 12.5006 19.1666C16.1673 19.1666 19.1673 16.1666 19.1673 12.5C19.1673 8.83331 16.1673 5.83331 12.5006 5.83331ZM12.5006 18.3333C9.29228 18.3333 6.66729 15.7083 6.66729 12.5C6.66729 9.29161 9.29228 6.66661 12.5006 6.66661C15.709 6.66661 18.334 9.29161 18.334 12.5C18.334 15.7083 15.709 18.3333 12.5006 18.3333Z" fill="black"/>
 * <path id="Vector_3" d="M12.4994 7.91669C9.95771 7.91669 7.91602 9.95834 7.91602 12.5C7.91602 15.0417 9.95767 17.0834 12.4994 17.0834C15.0411 17.0834 17.0827 15.0417 17.0827 12.5C17.0827 9.95834 15.041 7.91669 12.4994 7.91669ZM12.4994 16.25C10.416 16.25 8.74937 14.5834 8.74937 12.5C8.74937 10.4167 10.416 8.75004 12.4994 8.75004C14.5827 8.75004 16.2494 10.4167 16.2494 12.5C16.2494 14.5834 14.5827 16.25 12.4994 16.25Z" fill="black"/>
 * <path id="Vector_4" d="M19.166 4.58331C18.4577 4.58331 17.916 5.12496 17.916 5.83331C17.916 6.54166 18.4577 7.0833 19.166 7.0833C19.8744 7.0833 20.416 6.54166 20.416 5.83331C20.416 5.12496 19.8744 4.58331 19.166 4.58331Z" fill="black"/>
 * </g>
 * </g>
 * </g>
 * </g>
 * <defs>
 * <clipPath id="clip0">
 * <rect width="25" height="25" fill="white"/>
 * </clipPath>
 * </defs>
 * </svg>
 *
 * ---------------------------------
 *
 * CONFIGURATION
 * ---------------------------------
 * {
 * 	"#InstagramIcon": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMinYMin meet",
 * 		"width": 25,
 * 		"height": 25
 * 	},
 * 	"#Group": {
 * 		"type": "SELECTOR",
 * 		"constraint": "none",
 * 		"width": 25,
 * 		"height": 25
 * 	},
 * 	"#Vector": {
 * 		"type": "SELECTOR",
 * 		"constraint": "none",
 * 		"width": 2.5,
 * 		"height": 2.4999914169311523
 * 	},
 * 	"transforms": {}
 * }
 * ---------------------------------
 *
 * DESCRIPTION
 * ---------------------------------
 * No description provided!
 * ---------------------------------
 */

/** Component Properties Interface */
export type tProps = {
  style?: tStyle;
  svgStyle?: tStyle;
  debug?: boolean;
  isInsideScrollView?: boolean;
  svgRef?: () => void;
  onAnimationComplete?: () => void;
};
/***/

/***/

export type tStyle = StyleProp<ViewStyle>;
export type tTextStyle = StyleProp<TextStyle>;
/** Convenience for prop insertion from ast (no-color-literals/no-inline-styles) */

/* eslint-disable react-native/no-color-literals */

/* eslint-disable react-native/no-inline-styles */

/** Local Styles */

const kLocalStyles = StyleSheet.create({
  kOverlay: {
    left: 0,
    position: "absolute",
    top: 0,
  },
});
/***/

/***/

/**
 * Auto-Generated Imp.Blue Component based on your design!
 * @param {tProps} props Developer interface to the component!
 * @returns {JSX.Element} JSX
 *
 * Description --
 * No description provided!
 */

export const InstagramIcon = (props: {
  style?: tStyle;
  svgStyle?: tStyle;
  debug?: boolean;
  isInsideScrollView?: boolean;
  svgRef?: () => void;
  onAnimationComplete?: () => void;
}): JSX.Element => {
  const {
    style = {
      width: 25,
      height: 25,
    },
    svgStyle = {
      width: "100%",
      height: "100%",
    },
    svgRef,
  } = props;
  /** Component Internal State */

  /** Component Internal Functions */

  /** Custom React-Hooks */

  /**
   * Custom hook to emulate onLayout events
   * (For use in web env only!)
   */
  /** End Custom React-Hooks */

  /** Component Render (Javascript-React Markup) */

  if (Platform.OS === "web") {
    return (
      <View style={style}>
        <Svg
          fill="none"
          id="svg_root"
          ref={svgRef}
          {...props}
          style={svgStyle}
          preserveAspectRatio="xMinYMin meet"
          viewBox="0 0 25 25"
        >
          <G id="InstagramIcon" clipPath="url(#clip0)">
            <Svg preserveAspectRatio="none" viewBox="0 0 25 25">
              <G id="Group">
                <G id="Group_2">
                  <G id="Group_3">
                    <Svg preserveAspectRatio="none" viewBox="0 0 25 25">
                      <Path
                        id="Vector"
                        d="M17.875 0H7.125C3.20835 0 0 3.20835 0 7.125V17.875C0 21.7916 3.20835 25 7.125 25H17.875C21.7916 25 25 21.7916 25 17.875V7.125C25 3.20835 21.7916 0 17.875 0ZM24.1667 17.875C24.1667 21.3333 21.3333 24.1667 17.875 24.1667H7.125C3.66665 24.1667 0.83335 21.3333 0.83335 17.875V7.125C0.83335 3.66665 3.6667 0.83335 7.125 0.83335H17.875C21.3333 0.83335 24.1667 3.6667 24.1667 7.125V17.875Z"
                        fill="black"
                        strokeWidth="1"
                        vectorEffect="non-scaling-stroke"
                      />
                    </Svg>
                    <Path
                      id="Vector_2"
                      d="M12.5006 5.83331C8.83398 5.83331 5.83398 8.83331 5.83398 12.5C5.83398 16.1666 8.83398 19.1666 12.5006 19.1666C16.1673 19.1666 19.1673 16.1666 19.1673 12.5C19.1673 8.83331 16.1673 5.83331 12.5006 5.83331ZM12.5006 18.3333C9.29228 18.3333 6.66729 15.7083 6.66729 12.5C6.66729 9.29161 9.29228 6.66661 12.5006 6.66661C15.709 6.66661 18.334 9.29161 18.334 12.5C18.334 15.7083 15.709 18.3333 12.5006 18.3333Z"
                      fill="black"
                      strokeWidth="1"
                      vectorEffect="non-scaling-stroke"
                    />
                    <Path
                      id="Vector_3"
                      d="M12.4994 7.91669C9.95771 7.91669 7.91602 9.95834 7.91602 12.5C7.91602 15.0417 9.95767 17.0834 12.4994 17.0834C15.0411 17.0834 17.0827 15.0417 17.0827 12.5C17.0827 9.95834 15.041 7.91669 12.4994 7.91669ZM12.4994 16.25C10.416 16.25 8.74937 14.5834 8.74937 12.5C8.74937 10.4167 10.416 8.75004 12.4994 8.75004C14.5827 8.75004 16.2494 10.4167 16.2494 12.5C16.2494 14.5834 14.5827 16.25 12.4994 16.25Z"
                      fill="black"
                      strokeWidth="1"
                      vectorEffect="non-scaling-stroke"
                    />
                    <Path
                      id="Vector_4"
                      d="M19.166 4.58331C18.4577 4.58331 17.916 5.12496 17.916 5.83331C17.916 6.54166 18.4577 7.0833 19.166 7.0833C19.8744 7.0833 20.416 6.54166 20.416 5.83331C20.416 5.12496 19.8744 4.58331 19.166 4.58331Z"
                      fill="black"
                      strokeWidth="1"
                      vectorEffect="non-scaling-stroke"
                    />
                  </G>
                </G>
              </G>
            </Svg>
          </G>
          <Defs>
            <ClipPath id="clip0">
              <Path
                fill="white"
                id="clip0_elem0"
                d="M0 0 H25 a0,0 0 0 1 0,0 V25 a0,0 0 0 1 -0,0 H0 a0,0 0 0 1 -0,-0 V0 a0,0 0 0 1 0,-0z"
                strokeWidth="1"
                vectorEffect="non-scaling-stroke"
              />
            </ClipPath>
          </Defs>
        </Svg>
      </View>
    );
  }

  return (
    <View style={style}>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="xMinYMin meet"
        viewBox="0 0 25 25"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <Path
          id="Vector"
          d="M17.875 0H7.125C3.20835 0 0 3.20835 0 7.125V17.875C0 21.7916 3.20835 25 7.125 25H17.875C21.7916 25 25 21.7916 25 17.875V7.125C25 3.20835 21.7916 0 17.875 0ZM24.1667 17.875C24.1667 21.3333 21.3333 24.1667 17.875 24.1667H7.125C3.66665 24.1667 0.83335 21.3333 0.83335 17.875V7.125C0.83335 3.66665 3.6667 0.83335 7.125 0.83335H17.875C21.3333 0.83335 24.1667 3.6667 24.1667 7.125V17.875Z"
          fill="black"
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
        <Defs>
          <ClipPath id="clip0">
            <Path
              fill="white"
              id="clip0_elem0"
              d="M0 0 H25 a0,0 0 0 1 0,0 V25 a0,0 0 0 1 -0,0 H0 a0,0 0 0 1 -0,-0 V0 a0,0 0 0 1 0,-0z"
              strokeWidth="1"
              vectorEffect="non-scaling-stroke"
            />
          </ClipPath>
        </Defs>
      </Svg>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="xMinYMin meet"
        viewBox="0 0 25 25"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <Path
          id="Vector_2"
          d="M12.5006 5.83331C8.83398 5.83331 5.83398 8.83331 5.83398 12.5C5.83398 16.1666 8.83398 19.1666 12.5006 19.1666C16.1673 19.1666 19.1673 16.1666 19.1673 12.5C19.1673 8.83331 16.1673 5.83331 12.5006 5.83331ZM12.5006 18.3333C9.29228 18.3333 6.66729 15.7083 6.66729 12.5C6.66729 9.29161 9.29228 6.66661 12.5006 6.66661C15.709 6.66661 18.334 9.29161 18.334 12.5C18.334 15.7083 15.709 18.3333 12.5006 18.3333Z"
          fill="black"
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
        <Defs>
          <ClipPath id="clip0">
            <Path
              fill="white"
              id="clip0_elem0"
              d="M0 0 H25 a0,0 0 0 1 0,0 V25 a0,0 0 0 1 -0,0 H0 a0,0 0 0 1 -0,-0 V0 a0,0 0 0 1 0,-0z"
              strokeWidth="1"
              vectorEffect="non-scaling-stroke"
            />
          </ClipPath>
        </Defs>
      </Svg>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="xMinYMin meet"
        viewBox="0 0 25 25"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <Path
          id="Vector_3"
          d="M12.4994 7.91669C9.95771 7.91669 7.91602 9.95834 7.91602 12.5C7.91602 15.0417 9.95767 17.0834 12.4994 17.0834C15.0411 17.0834 17.0827 15.0417 17.0827 12.5C17.0827 9.95834 15.041 7.91669 12.4994 7.91669ZM12.4994 16.25C10.416 16.25 8.74937 14.5834 8.74937 12.5C8.74937 10.4167 10.416 8.75004 12.4994 8.75004C14.5827 8.75004 16.2494 10.4167 16.2494 12.5C16.2494 14.5834 14.5827 16.25 12.4994 16.25Z"
          fill="black"
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
        <Defs>
          <ClipPath id="clip0">
            <Path
              fill="white"
              id="clip0_elem0"
              d="M0 0 H25 a0,0 0 0 1 0,0 V25 a0,0 0 0 1 -0,0 H0 a0,0 0 0 1 -0,-0 V0 a0,0 0 0 1 0,-0z"
              strokeWidth="1"
              vectorEffect="non-scaling-stroke"
            />
          </ClipPath>
        </Defs>
      </Svg>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="xMinYMin meet"
        viewBox="0 0 25 25"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <Path
          id="Vector_4"
          d="M19.166 4.58331C18.4577 4.58331 17.916 5.12496 17.916 5.83331C17.916 6.54166 18.4577 7.0833 19.166 7.0833C19.8744 7.0833 20.416 6.54166 20.416 5.83331C20.416 5.12496 19.8744 4.58331 19.166 4.58331Z"
          fill="black"
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
        <Defs>
          <ClipPath id="clip0">
            <Path
              fill="white"
              id="clip0_elem0"
              d="M0 0 H25 a0,0 0 0 1 0,0 V25 a0,0 0 0 1 -0,0 H0 a0,0 0 0 1 -0,-0 V0 a0,0 0 0 1 0,-0z"
              strokeWidth="1"
              vectorEffect="non-scaling-stroke"
            />
          </ClipPath>
        </Defs>
      </Svg>
    </View>
  );
};
/***/

export default React.memo(InstagramIcon);
